export const permissions = [
  'customersModify',
  'otherEntitiesModify',
  'dashboardReportsView',
  'productsModify',
  'ordersModify',
  'ordersComplete',
  'ordersVoidTransaction',
  'purchaseOrderModify',
  'purchaseOrderComplete',
  'settingsModify',
  'integrationsModify',
] as const;

export type PermissionField = typeof permissions[number];

export type RolePermissions = Record<PermissionField, boolean>;

export const totalPermissionCount = permissions.length;

export const fillPermissions = (value: boolean): RolePermissions =>
  permissions.reduce((flags, field) => ({ ...flags, [field]: value }), {} as RolePermissions);

export const nonePermissions = (): RolePermissions => fillPermissions(false);

export const standardPermissions = (): RolePermissions =>
  ({ ...fillPermissions(true), settingsModify: false, integrationsModify: false });

export const enabledPermissionCount = (flags: RolePermissions): number =>
  permissions.filter(field => flags[field]).length;

export const pickPermissions = (source: RolePermissions): RolePermissions =>
  permissions.reduce((flags, field) => ({ ...flags, [field]: source[field] }), {} as RolePermissions);
